import firebase from 'firebase';
import { db } from './firebase';
import { firestoreKeys } from '../utils/constants';

export default function useMessagesService() {
  const updateConversationsWithNewUserData = (userId, updatedData) =>
    db
      .collection(firestoreKeys.CONVERSATIONS)
      .where('userIds', 'array-contains', userId)
      .get()
      .then((querySnapshot) => {
        const batch = firebase.firestore().batch();
        querySnapshot.forEach((doc) => {
          const conversation = doc.data();
          const userIndex = conversation.users.findIndex((user) => user.id === userId);
          if (userIndex !== -1) {
            conversation.users[userIndex] = updatedData;
            const conversationRef = db.collection(firestoreKeys.CONVERSATIONS).doc(doc.id);
            batch.update(conversationRef, { users: conversation.users });
          }
        });
        return batch.commit();
      })
      .catch((error) => {
        console.error('Error updating user data in conversations: ', error);
        throw error;
      });

  const createConversation = (conversation, message) =>
    db.collection(firestoreKeys.CONVERSATIONS).add({
      ...conversation,
      lastMessage: message,
      lastUpdated: new Date(),
    });

  const createMessage = (conversationId, message) =>
    db.collection(firestoreKeys.CONVERSATIONS).doc(conversationId).collection(firestoreKeys.MESSAGES).add(message);

  const updateConversation = (conversationId, data) =>
    db.collection(firestoreKeys.CONVERSATIONS).doc(conversationId).update(data);

  const batchUpdateMessagesToRead = (conversation, messages, currentUserId) => {
    const batch = firebase.firestore().batch();

    messages.forEach((message) => {
      const messageRef = db
        .collection(firestoreKeys.CONVERSATIONS)
        .doc(conversation.id)
        .collection(firestoreKeys.MESSAGES)
        .doc(message.id);
      batch.update(messageRef, { isRead: true });
    });

    if (conversation?.lastMessage?.isRead === false && conversation?.lastMessage?.userId !== currentUserId) {
      batch.update(db.collection(firestoreKeys.CONVERSATIONS).doc(conversation.id), {
        'lastMessage.isRead': true,
      });
    }

    return batch.commit().catch((error) => {
      console.error('Error updating messages', error);
    });
  };

  const archiveConversation = (conversationId, userId) =>
    db
      .collection(firestoreKeys.CONVERSATIONS)
      .doc(conversationId)
      .update({
        unArchivedUserIds: firebase.firestore.FieldValue.arrayRemove(userId),
      });

  return {
    updateConversationsWithNewUserData,
    createConversation,
    createMessage,
    updateConversation,
    batchUpdateMessagesToRead,
    archiveConversation,
  };
}
